import { Drawer, Empty, Spin } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState, Fragment, useMemo } from 'react';
import { uniqBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import RepeatItem from './RepeatItem';
import { TMyMeeting } from '@/common/basis/types/database/tmy-meeting';
import { getRepeatMeeting } from '@/common/http/meet';
import { isSuccessCode } from '@/common/utils/response';

function App(props: {
  currentCreateIndex: number;
  createList: TMyMeeting.CreateItem[];
  isOpenRepeatMeeting: boolean;
  setIsOpenRepeatMeeting: (isOpenRepeatMeeting: boolean) => void;
}) {
  const currentCreateIndex = props.currentCreateIndex;
  const isOpenDrawerRepeatMeeting = props.isOpenRepeatMeeting;
  const createList = props.createList;
  const setIsOpenDrawerRepeatMeeting = props.setIsOpenRepeatMeeting;

  const item = useMemo(() => createList[currentCreateIndex], [currentCreateIndex, createList]);
  const roomId = useMemo(() => item?.roomId ?? '', [item?.roomId]);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const [list, setList] = useState<TMyMeeting.CreateItem[]>();
  const { t } = useTranslation();

  // 周期按月份并且去重
  const monthPeriod = uniqBy(
    list?.map((value) => {
      const startTime = value?.startTime;
      const month = dayjs(startTime).format('MMM').replace(/^0/, '');
      const year = dayjs(startTime).format(t('YYYYFormat'));
      const key = dayjs(startTime).format('YYYY-MM');

      return { month, year, key };
    }),
    'key',
  );

  const requestGetRepeatMeeting = async () => {
    if (isRequestLoading) {
      return;
    }
    setIsRequestLoading(true);
    try {
      const endTime = new Date(dayjs().add(3, 'month').toString()).getTime();
      const resp = await getRepeatMeeting({ roomId, startTime: item?.startTime ?? 0, endTime });

      if (isSuccessCode(resp?.code)) {
        setList(resp.data);
      }
    } catch (err) {
      // TODO
    }

    setIsRequestLoading(false);
  };

  useEffect(() => {
    if (item) {
      requestGetRepeatMeeting();
    }

    return () => {
      setList([]);
    };
  }, [item]);

  return (
    <Drawer
      onClose={() => setIsOpenDrawerRepeatMeeting(false)}
      open={isOpenDrawerRepeatMeeting}
      styles={{ mask: { opacity: 0 }, content: { backgroundColor: '#f2f3f5' }, body: { padding: 0, margin: 0 } }}
      title={
        <div className='flex items-center justify-center'>
          <span className='text-[18px]'>{t('cycleMeeting')}</span>
        </div>
      }
    >
      {isRequestLoading ? (
        <div className='flex items-center justify-center'>
          <Spin className='mt-20' />
        </div>
      ) : item ? (
        list?.length ? (
          <div className='h-full'>
            <div className='p-4'>
              <div className='rounded-xl bg-[#fff] p-3 py-4'>
                <span className='break-words text-[16px]'>{item?.roomName}</span>
              </div>
            </div>
            <div className='flex flex-wrap items-center justify-between overflow-hidden p-4 py-2 text-[14px] text-[rgba(19,20,21,.4)]'>
              <div>
                <span>{item.roomId}</span>
              </div>
              <div>
                <span>{t('showBookingMeetingTip')}</span>
              </div>
            </div>
            <div className='flex-1 overflow-hidden'>
              <div className='m-4 overflow-hidden rounded-xl bg-[#fff] p-3 pb-0'>
                {monthPeriod.map((value) => {
                  const currentList = list?.filter(
                    (val) => dayjs(val?.startTime).format('MMM').replace(/^0/, '') === value.month,
                  ); // 筛选周期月份

                  return (
                    <Fragment key={value.key}>
                      <div className='flex items-center justify-between'>
                        <div className='text-[16px] font-medium'>
                          <span>{value.month}</span>
                        </div>
                        <div className='text-[14px] text-[rgba(19,20,21,.4)]'>
                          <span>{value.year}</span>
                        </div>
                      </div>
                      {currentList.map((val) => (
                        <RepeatItem item={val} key={val?.startTime} />
                      ))}
                    </Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        ) : (
          <Empty className='mt-20' description={t('noneMeeting')} />
        )
      ) : (
        <></>
      )}
    </Drawer>
  );
}

export default App;
